export const LANGUAGES_SLICE_NAME = 'languages';
